export default {
  listaEvents: [],
  event: {
    nome: '',
    descricao: '',
    tipoEvento: {
      id: null,
      nome: '',
      ativo: true,
    },
    local: '',
    dataInicial: '',
    dataFinal: '',
    hora: null,
    horaFinal: null,
    qtoVaga: 0,
    publicoAlvo: '',
    status: '',
    ativo: true,
    temCobranca: false,
    valor: 0,
    tipoPagamentoRecebimento: {
      id: null,
      descricao: '',
    },
  },
}
